import { useEffect, useState } from "react";

export function useMobileHeaderPeep() {
  const [hasHeaderPeeped, setHasHeaderPeeped] = useState(false);

  useEffect(function subscribeToMobileHeaderPeepEvent() {
    const handleHeaderPeepUpdated = (e: Event) => {
      const {
        detail: { peeped = false },
      } = e as CustomEvent;
      setHasHeaderPeeped(peeped);
    };

    window.addEventListener(
      "jl-events.browser.mobileHeaderPeepUpdated",
      handleHeaderPeepUpdated,
    );

    return function cleanupMobileHeaderPeepEvent() {
      window.removeEventListener(
        "jl-events.browser.mobileHeaderPeepUpdated",
        handleHeaderPeepUpdated,
      );
    };
  }, []);

  return hasHeaderPeeped;
}
